import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7aaaf48e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "系统页面配置", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "主题设置", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "界面设置", -1));
const _hoisted_4 = {
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "导航设置", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "左侧模式:", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "顶部模式:", -1));
import { ref } from 'vue';
import generateColors from '@/utils/color';
import { useToggle } from '@vueuse/shared';
import { useDark } from '@vueuse/core';
import { Sunny, Moon } from '@element-plus/icons-vue';
import { useStore } from 'vuex';
import { stringToBooleans } from '@/utils/stringToBoolean';
export default /*#__PURE__*/_defineComponent({
  __name: 'setting',
  setup(__props) {
    const store = useStore();
    const drawer2 = ref(false);
    const direction = ref('rtl');
    const isDark = useDark();
    const toggleDark = useToggle(isDark);
    const themeColor = ref('#1e90ff'); // 假装这个是从后台获取的主题色
    const sidebarLogoType = ref(stringToBooleans(localStorage.getItem('sidebarLogo') || ''));
    const leftsty = ref();
    const topsty = ref();
    const predefineColors = ref(['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', 'rgba(255, 69, 0, 0.68)', 'rgb(255, 120, 0)', 'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)', '#c7158577']);
    // 初始化
    const init = () => {
      cunst(localStorage.getItem('changeMoshi'));
    };
    init();
    const toggleTheme = () => {
      const colorMap = generateColors(themeColor.value);
      const el = document.documentElement;
      el.style.setProperty('--el-color-primary', themeColor.value);
      // 生成不同1-9的透明度
      Object.keys(colorMap).forEach(key => {
        el.style.setProperty(`--el-color-primary-${key}`, colorMap[key]);
      });
    };
    // 左侧菜单Logo
    const chageSidebarLogoType = event => {
      store.commit('login/changeSidebarLogo', event);
      localStorage.setItem('sidebarLogo', event);
    };
    const moshi = num => {
      store.commit('login/changeMoshi', num);
      localStorage.setItem('changeMoshi', num + '');
      cunst(num);
    };
    function cunst(num) {
      if (num === '1' || num == null) {
        leftsty.value = {
          border: '1px solid red',
          background: 'red'
        };
        topsty.value = {
          border: '1px solid #dcdfe6',
          background: '#dcdfe6'
        };
      } else {
        topsty.value = {
          border: '1px solid red',
          background: 'red'
        };
        leftsty.value = {
          border: '1px solid #dcdfe6',
          background: '#dcdfe6'
        };
      }
    }
    return (_ctx, _cache) => {
      const _component_Tools = _resolveComponent("Tools");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        style: {
          "margin": "10px",
          "padding-top": "10px"
        },
        onClick: _cache[0] || (_cache[0] = $event => drawer2.value = true)
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Tools)]),
        _: 1
      })]), _createVNode(_component_el_drawer, {
        modelValue: drawer2.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => drawer2.value = $event),
        direction: direction.value,
        size: "20%"
      }, {
        header: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_divider, null, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_switch, {
          style: {
            "padding-top": "8px"
          },
          modelValue: _unref(isDark),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(isDark) ? isDark.value = $event : null),
          "inline-prompt": "",
          "active-icon": _unref(Moon),
          "inactive-icon": _unref(Sunny),
          onChange: _unref(toggleDark)
        }, null, 8, ["modelValue", "active-icon", "inactive-icon", "onChange"])]), _createElementVNode("div", null, [_createVNode(_component_el_divider, null, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createElementVNode("div", null, [_createTextVNode(" 界面颜色："), _createVNode(_component_el_color_picker, {
          modelValue: themeColor.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => themeColor.value = $event),
          onChange: toggleTheme,
          predefine: predefineColors.value
        }, null, 8, ["modelValue", "predefine"])]), _createElementVNode("div", _hoisted_4, [_createTextVNode(" 侧边栏 Logo: "), _createVNode(_component_el_switch, {
          style: {
            "padding-top": "8px"
          },
          modelValue: sidebarLogoType.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => sidebarLogoType.value = $event),
          onChange: _cache[4] || (_cache[4] = $event => chageSidebarLogoType(sidebarLogoType.value))
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_el_divider, null, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createElementVNode("div", {
          style: {
            "margin-top": "20px",
            "display": "flex"
          },
          onClick: _cache[5] || (_cache[5] = $event => moshi('1'))
        }, [_hoisted_6, _createElementVNode("div", {
          class: "moshi",
          style: _normalizeStyle(leftsty.value)
        }, null, 4)]), _createElementVNode("div", {
          style: {
            "margin-top": "20px",
            "display": "flex"
          },
          onClick: _cache[6] || (_cache[6] = $event => moshi('2'))
        }, [_hoisted_7, _createElementVNode("div", {
          class: "moshi",
          style: _normalizeStyle(topsty.value)
        }, null, 4)])])])]),
        _: 1
      }, 8, ["modelValue", "direction"])], 64);
    };
  }
});